import { useEffect, useState } from 'preact/hooks';
import { api, flash, type SavedReply } from '../state';

const blank = { id: 0, title: '', body: '', sortOrder: 0 };

/** Admin: the saved replies agents pick from (⚡ or "/" in the chat box). */
export function Replies() {
  const [list, setList] = useState<SavedReply[]>([]);
  const [edit, setEdit] = useState<SavedReply | null>(null);
  const [error, setError] = useState('');
  const load = () => api<SavedReply[]>('/saved-replies').then(setList);
  useEffect(() => void load(), []);

  async function save(e: Event) {
    e.preventDefault();
    if (!edit) return;
    setError('');
    const { id, ...body } = edit;
    try {
      if (id) await api(`/saved-replies/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
      else await api('/saved-replies', { method: 'POST', body: JSON.stringify({ ...body, sortOrder: list.length + 1 }) });
      flash('Saved reply saved.');
      setEdit(null);
      load();
    } catch (err) {
      setError((err as Error).message);
    }
  }

  async function remove(r: SavedReply) {
    if (!confirm(`Delete “${r.title}”?`)) return;
    await api(`/saved-replies/${r.id}`, { method: 'DELETE' });
    load();
  }

  return (
    <div class="page">
      <div class="page-head">
        <h1>Saved replies</h1>
        <button class="btn primary" onClick={() => setEdit({ ...blank })}>Add reply</button>
      </div>
      <p class="muted">Agents insert these with the ⚡ button or by typing <strong>/</strong> in the chat box. <code>{'{first_name}'}</code> becomes the visitor’s first name.</p>
      <table class="table">
        <thead><tr><th>Title</th><th>Message</th><th></th></tr></thead>
        <tbody>
          {list.map((r) => (
            <tr>
              <td><strong>{r.title}</strong></td>
              <td>{r.body}</td>
              <td class="nowrap"><button class="link" onClick={() => setEdit(r)}>Edit</button> · <button class="link" onClick={() => remove(r)}>Delete</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {edit && (
        <div class="drawer" onClick={(e) => e.target === e.currentTarget && setEdit(null)}>
          <form class="drawer-panel form" onSubmit={save}>
            <button type="button" class="link close" onClick={() => setEdit(null)}>Close</button>
            <h2>{edit.id ? 'Edit saved reply' : 'Add saved reply'}</h2>
            <label class="field"><span>Title</span><input value={edit.title} required maxLength={80} onInput={(e) => setEdit({ ...edit, title: (e.target as HTMLInputElement).value })} /></label>
            <label class="field"><span>Message</span><textarea rows={5} value={edit.body} required maxLength={2000} onInput={(e) => setEdit({ ...edit, body: (e.target as HTMLTextAreaElement).value })} /></label>
            {error && <p class="error">{error}</p>}
            <button class="btn primary">Save</button>
          </form>
        </div>
      )}
    </div>
  );
}
